import React from 'react';

const Footer = () => {
    return (
            <p style={{backgroundColor: "#ddd", textAlign:"center", padding: "1.4rem", marginBottom: "0"}}>
               &copy; copyright all right reserved 2021. Abu Bakkar Siddik  
            </p>
    )
}

export default Footer
